import React, { FC } from 'react';
import cn from 'classnames';
import styles from './heading.module.scss';

type HeadingProps = {
    level?: 1 | 2 | 3 | 4 | 5 | 6;
    align?: 'left' | 'center' | 'right';
    children: React.ReactNode;
    className?: string;
};

export const Heading: FC<HeadingProps> = ({
    level = 1,
    align = 'left',
    children,
    className,
}) => {
    const Tag = `h${level}` as keyof JSX.IntrinsicElements;

    return (
        <Tag className={cn(styles[`h${level}`], styles[align], className)}>
            {children}
        </Tag>
    );
};

export default Heading;
